export default __webpack_public_path__ + "static/media/ka_group.5ee6d480.png";